import React from 'react'
import { Flex } from '@chakra-ui/react'

import TeamChatInput from './input'
import TeamChatHeader from './header'
import TeamChatMessageList from './message-list'
import TeamChatConversationProvider from './provider'
import TeamChatAttachmentsProvider from './input/attachments/provider'

interface Props {
    chatId: string
    compact?: boolean
    onClose?: () => void
    onMinimize?: () => void
}

/**
 * Conversation body without the team-chat sidebar. Used by the full page
 * and by popped-out windows.
 */
export default function TeamChatConversationPanel({
    chatId,
    compact = false,
    onClose,
    onMinimize,
}: Props) {
    return (
        <TeamChatConversationProvider chatId={chatId}>
            <Flex
                flex={1}
                minH={0}
                borderWidth={compact ? 0 : 1}
                borderColor="gray.200"
                flexDir="column"
                bg="white"
                rounded={compact ? 0 : '2xl'}
                shadow={compact ? 'none' : 'blue.lg'}
            >
                <TeamChatHeader
                    compact={compact}
                    onClose={onClose}
                    onMinimize={onMinimize}
                />
                <TeamChatMessageList />
                <TeamChatAttachmentsProvider teamChatId={chatId}>
                    <TeamChatInput />
                </TeamChatAttachmentsProvider>
            </Flex>
        </TeamChatConversationProvider>
    )
}
